<template>
  <div class="basicInfoAgentList">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
        @click="gotoDetail(item.OAId)"
      >
        <div class="list-item">{{ $t.basicInfo.createDate }}：{{ item.CreateDate }}</div>
        <div class="list-item">
          {{ $t.basicInfo.createdBy }}：{{ item.CreateUserName }}
        </div>
        <div class="list-item">{{ $t.basicInfo.cityName }}：{{ item.CityName }}</div>
        <div class="list-item">
          {{ $t.meta.wbType1 }}：<van-icon
            name="success"
            v-if="item.IsAir"
            color="#1890ff"
            size="14"
          />
        </div>
        <div class="list-item">
          {{ $t.meta.wbType2 }}：<van-icon
            name="success"
            v-if="item.IsSea"
            color="#1890ff"
            size="14"
          />
        </div>
        <div class="list-item">
          {{ $t.meta.wbType6 }}：<van-icon
            name="success"
            v-if="item.IsRailway"
            color="#1890ff"
            size="14"
          />
        </div>
        <div class="list-item">
          {{ $t.meta.wbType7 }}：<van-icon
            name="success"
            v-if="item.IsWarehouse"
            color="#1890ff"
            size="14"
          />
        </div>
        <div class="list-item">
          {{ $t.meta.wbType8 }}：<van-icon
            name="success"
            v-if="item.IsCustomBorkerAgent"
            color="#1890ff"
            size="14"
          />
        </div>
        <div class="list-item">
          {{ $t.meta.wbType9 }}：<van-icon
            name="success"
            v-if="item.IsPickUpDelivery"
            color="#1890ff"
            size="14"
          />
        </div>
        <div class="list-item">
          {{ $t.meta.isConsolidation }}：<van-icon
            name="success"
            v-if="item.IsConsolidation"
            color="#1890ff"
            size="14"
          />
        </div>
      </div>
    </van-list>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoCreate">{{
        $t.basicInfo.addAgentButton
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { List, Icon, Image, Button } from "vant";

Vue.use(List).use(Icon).use(Image).use(Button);

export default {
  name: "basicInfoAgentList",
  data() {
    return {
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  created() {
    const { CustomerNumber } = this.$route.query;
    this.customerNumber = CustomerNumber;
  },
  methods: {
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "basicInfoAgentDetail",
        name: "basicInfoAgentDetail",
        query: [
          {
            name: "OAId",
            value: id,
          },
          {
            name: "CustomerNumber",
            value: this.customerNumber,
          },
        ],
      });
    },
    gotoCreate() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "basicInfoAgentDetail",
        name: "basicInfoAgentDetail",
        query: [
          {
            name: "CustomerNumber",
            value: this.customerNumber,
          },
        ],
      });
    },
    getList() {
      var param = {
        CustomerNumber: this.customerNumber,
      };
      this.$api.customerManagement
        .getOverseasAgentList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data);
          this.loading = false;
          this.error = false;
          this.errorText = "";
          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.basicInfoAgentList {
  .list {
    width: 100%;
    display: inline-block;
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
